import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAllClientes } from "../../redux/clientes/clientesAction";
import ClienteCard from "./clientesCard";
import '../../index.css';

export default function InformesClientes(){
    const dispatch = useDispatch();
    const clientes = useSelector(state => state.clientes.allClientes);
    const [clientesAux, setClientesAux] = useState();
    const [search, setSearch] = useState()

    useEffect(() => {
        dispatch(getAllClientes())
    }, [dispatch]);

    console.log(clientes);

    const handleChange = (e) => {
        const {value} = e.target;
        console.log(value);
        
        setSearch(value)
    }

    const searchClientes = () => {
        if(clientesAux === undefined){
            let result = clientes.filter(e => {
               if(e.nombre.toString().toLowerCase().includes(search.toLowerCase())) {
                return e
               }
            })
            console.log(result);
            
            setClientesAux(result)
        } else {
            let result = clientesAux.filter(e => {
                if(e.nombre.toString().toLowerCase().includes(search.toLowerCase())) {
                 return e
                }
             })
             console.log(result);
             
             setClientesAux(result)
        }
    }

    const limpiarSearch = () => {
        setClientesAux(clientes)
    }
    
    return(
        <>
         <div className="bg-custom container-custom">
            <p className="text-orange-500">Informes Clientes</p>
            <div className="h-[100px] text-orange-500 bg-gray-700">
                <div className="flex justify-center items-center w-[240px] pt-[10px] ml-2">
                    <label className="text-[11pt] font-bold mr-1">Cliente</label>
                    <input
                        className="border border-slate-700 rounded w-44 h-4 text-center text-[10pt] font-semibold text-black bg-sky-200 placeholder-gray-600"
                        type="text"
                        placeholder="Cliente"
                        value={search}
                        onChange={handleChange} 
                    />
                </div> 
                <div className="flex justify-around ml-2 w-[240px]">
                <button className="text-[11pt] font-bold hover:text-orange-300" onClick={searchClientes}>Buscar</button>  
                <button className="text-[11pt] font-bold hover:text-orange-300" onClick={limpiarSearch}>Limpiar</button>    
                </div>                         
            </div>
            <div>
                <div>
                    <table>
                        <thead>
                            <tr className="text-orange-500 text-[12pt] font-bold border-y border-white">
                                <td className="w-[60px] text-center">Codigo</td>
                                <td className="w-[300px]">Nombre</td>                                
                                <td className="w-[100px]">Cuit/Cuil/DNI</td>
                                <td className="w-[150px]">Ciudad</td>
                                <td className="w-[150px]">Direccion</td>
                                <td className="w-[50px]">CP</td>
                                <td className="w-[50px]">Zona</td>
                                <td className="w-[150px]">Telefono</td>
                                <td className="w-[173px]">Notas</td>
                            </tr>
                        </thead>
                    </table>
                </div>
                {!clientesAux ? clientes.map(e=> (
                    <ClienteCard 
                    key={e._id}
                    id={e._id}
                    numCliente={e.numCliente}
                    nombre={e.nombre}                    
                    cuitCuilDni={e.cuitCuilDni}
                    ciudad={e.ciudad}
                    direccion={e.direccion}
                    cp={e.cp}
                    zona={e.zona}
                    telefono={e.telefono}
                    notas={e.notas}
                    />
                )) : 
                clientesAux.map(e=> (
                    <ClienteCard 
                    key={e._id}
                    id={e._id}
                    numCliente={e.numCliente}
                    nombre={e.nombre}                    
                    cuitCuilDni={e.cuitCuilDni}
                    ciudad={e.ciudad}
                    direccion={e.direccion}
                    cp={e.cp}
                    zona={e.zona}
                    telefono={e.telefono}
                    notas={e.notas}
                    />
                ))
                }
            </div>
        </div>
        </>
    )
}